import type { MainProcessDiagnosticContext } from '@m43/bridge-interface';
import { electronBridge } from '../electron-bridge/electron-bridge';

const IPC_TIMEOUT_MS = 5000;

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('IPC timeout')), ms);
        promise.then(
            (val) => {
                clearTimeout(timer);
                resolve(val);
            },
            (err) => {
                clearTimeout(timer);
                reject(err);
            }
        );
    });
}

/**
 * Fetches the electron main-process diagnostic context over IPC. Returns null on
 * web (no bridge) or if the IPC call fails / times out.
 */
export async function fetchMainProcessContext(): Promise<MainProcessDiagnosticContext | null> {
    if (electronBridge && 'getDiagnosticContext' in electronBridge) {
        try {
            return await withTimeout(
                (electronBridge as {
                    getDiagnosticContext: () => Promise<MainProcessDiagnosticContext>;
                }).getDiagnosticContext(),
                IPC_TIMEOUT_MS
            );
        } catch {
            return null;
        }
    }

    return null;
}
